module.exports = __webpack_public_path__ + "Report_Banner.png?81be50de76e9c7ee7515f2a7e72c5e90";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Report/Report_Banner.png
// module id = 60
// module chunks = 0